export { LoggerService } from 'sce-core';
// #TODO-LIBRARY



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/1_SCE_CI_CD_SIT/src/app/core/logger.service.ts